import { useDispatch, useSelector } from 'react-redux';
import {
  closeAllDialogAction,
  closeDialogAction,
  closeMobileNarvarAction,
  closeNarvarAction,
  foldNarvarAction,
  globalClearAction,
  openDialogAction,
  openMobileNarvarAction,
  openNarvarAction,
  toggleMobileNarvarAction,
  toggleNarvarAction,
  unfoldNarvarAction,
} from './store/reducer';
import {
  dialogsSelector,
  foldedSelector,
  mobileOpenedSelector,
  openedSelector,
  dialogDataSelector,
} from './store/selector';

export function useGlobalCore() {
  const opened = useSelector(openedSelector);
  const folded = useSelector(foldedSelector);
  const mobileOpened = useSelector(mobileOpenedSelector);
  const dialogs = useSelector(dialogsSelector);
  const dialogData = useSelector(dialogDataSelector);
  const dispatch = useDispatch();

  return {
    opened,
    folded,
    mobileOpened,
    dialogs,
    dialogData,
    toggleNarvar: () => dispatch(toggleNarvarAction()),
    openNarvar: () => dispatch(openNarvarAction()),
    closeNarvar: () => dispatch(closeNarvarAction()),
    foldNarvar: () => dispatch(foldNarvarAction()),
    unfoldNarvar: () => dispatch(unfoldNarvarAction()),
    toggleMobileNarvar: () => dispatch(toggleMobileNarvarAction()),
    openMobileNarvar: () => dispatch(openMobileNarvarAction()),
    closeMobileNarvar: () => dispatch(closeMobileNarvarAction()),
    openDialog: (dialog: string, data?: any) => dispatch(openDialogAction({dialog, data})),
    closeDialog: (dialog: string) => dispatch(closeDialogAction(dialog)),
    closeAllDialog: () => dispatch(closeAllDialogAction()),
    clearGlobal: () => dispatch(globalClearAction()),
  };
}
